<template>
    <span v-if="options.verticalText" v-html="options.verticalText" class="vertical_text absolute top-0 left-0 transform -rotate-180 font-bold whitespace-nowrap" :class="['text-' + options.color]"></span>
</template>

<script>
    export default {
        name: 'VerticalText',
        props: {
            options: null
        }
    };
</script>

<style lang="scss" scoped>
    .vertical_text {
        writing-mode: tb-rl;
    }
</style>
